"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.HomepageLinks = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _Link = require("../../../react-static/components/Link");

var HomepageLinks =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(HomepageLinks, _Component);

  function HomepageLinks(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = HomepageLinks.prototype;

  _proto.render = function render() {
    return _react.default.createElement("div", null, _react.default.createElement(_Link.Link, {
      to: "/posts/"
    }, _react.default.createElement("h2", null, "Our Posts")), _react.default.createElement("h2", null, "Packing Lists"), _react.default.createElement("ul", null, _react.default.createElement(_Link.Link, {
      to: "/packing/category/"
    }, _react.default.createElement("li", null, "Packing Items by Category")), _react.default.createElement(_Link.Link, {
      to: "/packing/plan-for/"
    }, _react.default.createElement("li", null, "Packing Items by Aspect"))), _react.default.createElement("h2", null, "Trips"), _react.default.createElement("ul", null, _react.default.createElement(_Link.Link, {
      to: "/trip/pre-travel-checklist/"
    }, _react.default.createElement("li", null, "Pre-Travel Checklist")), _react.default.createElement(_Link.Link, {
      to: "/trip/planner/"
    }, _react.default.createElement("li", null, "Trip Planner"))));
  };

  return HomepageLinks;
}(_react.Component);

exports.HomepageLinks = HomepageLinks;